import { useCallback, useState } from 'react';

import { useChatbotState } from './useChatbotState';

export const useShowHistory = () => {
  const { isFullScreen, toggleFullScreen, close } = useChatbotState();
  const [showHistory, setShowHistory] = useState(false);

  const handleCloseChatbot = useCallback(() => {
    setShowHistory(false);
    if (isFullScreen) {
      toggleFullScreen();
    }
    close();
  }, [close, isFullScreen, toggleFullScreen]);

  const toggleHistory = useCallback(() => {
    setShowHistory((prev) => !prev);
  }, []);

  return { showHistory, setShowHistory, toggleHistory, handleCloseChatbot };
};
